<template>
  <div>
    <ContainerBasic classes="max-w-screen-lg mx-auto">
      <div class="text-center mx-md">
        <div
          v-if="priceHeading !== t('office.forFree')"
          class="text-3xl font-bold"
        >
          {{ priceHeading }}
        </div>
        <div v-else class="text-2xl font-bold">
          {{ priceHeading }}
        </div>
        <div class="text-sm">
          {{ t(blockData.text ?? '') }}
        </div>
        <ButtonBasic
          :label="t('office.contactButton')"
          :btn-style="EButtonStyle.CTA"
          :slim="true"
          classes="mx-auto inline-block mt-md print:hidden w-full sm:w-auto "
          bg-color="#555555"
          @click="scrollToForm()"
        />
      </div>
    </ContainerBasic>
    <div class="pagebreak"></div>
  </div>
</template>

<script setup lang="ts">
import { EButtonStyle } from '@/@types/basic-button';
import { scrollToElement } from '@/helpers/scroll';
import ContainerBasic from '@/components/components/container-basic.vue';
import ButtonBasic from '~~/src/components/components/core/basic-button/vdv/basic-button.vue';
import type { CTAOfficeData } from '../blockTypes';
import type { OfficePage } from '~~/src/server/transformers/page/officePage';

const { t, n } = useTrans();

defineProps({
  blockData: {
    type: Object as PropType<CTAOfficeData>,
    required: true,
  },
});

const pageData = usePageData<OfficePage>();
const priceHeading = generatePriceHeading();

const scrollToForm = () => {
  const formElements = document.querySelectorAll('*[id^="FormContainer"]');
  if (formElements.length > 0) {
    scrollToElement(formElements[0]);
  }
  return;
};

function generatePriceHeading(): string {
  const labelData = pageData.value.office.price as string | number;
  if (labelData) {
    const lableDataAsNumber: number =
      typeof labelData === 'string'
        ? parseFloat(labelData as string)
        : (labelData as number);
    const priceNumber = n(
      lableDataAsNumber,
      lableDataAsNumber % 1 === 0 ? 'currencyNoCents' : 'currency',
    );
    return lableDataAsNumber === 0
      ? t('office.forFree')
      : t('office.cta.heading', {
          price: priceNumber,
        });
  } else {
    return t('office.notSpecified');
  }
}
</script>
